import { AnalyticsContext } from '@carvana/eventable-clickstream';
import Content from '@carvana/seo-contentmod';
import { useContext } from 'react';
import type { SeoContent } from '~/contracts/Seo';

type OwnProps = {
  mods?: SeoContent;
};

export default function ContentMods({ mods }: OwnProps) {
  const { trackEvent } = useContext(AnalyticsContext);

  return mods?.contentMod ? (
    <Content
      contentMods={mods}
      assetsUrl={`${process.env.CVNA_APP_ASSETS_CDN}`}
      trackEvent={trackEvent}
    />
  ) : null;
}
